"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwoFactorWithPhoneValidateCallViewContainer = void 0;
var _SourceProvider = require("../SourceProvider");
var _TwoFactorWithPhoneValidateCallViewContainer = require("./TwoFactorWithPhoneValidateCallViewContainer");
const TwoFactorWithPhoneValidateCallViewContainer = exports.TwoFactorWithPhoneValidateCallViewContainer = (0, _SourceProvider.SourceProvider)(_TwoFactorWithPhoneValidateCallViewContainer.TwoFactorWithPhoneValidateCallViewContainer);